// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"48abaff9","502":"dec4c112"}[chunkId] + ".chunk.css";
};